import sortBySelect from './sortBySelect.vue';

export default sortBySelect;
